import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_329: DocMigration = {
  maxSchemaVersion: "0.0.329",
  description:
    "Add missing entityType to and add plan set template configs to doc entityRefs if parent plan set template exists in entityRefs",
  apply(json: any) {
    if (Object.keys(json.entityRefs ?? {}).length === 0) {
      return json;
    }

    for (const id in json.planSetTemplateConfigs) {
      json.planSetTemplateConfigs[id] = {
        ...json.planSetTemplateConfigs[id],
        entityType: "PLAN_SET_TEMPLATE_CONFIG",
      };

      interface PlanSetTemplate {
        id: string;
      }

      const planSetTemplateConfig: Record<string, any> = json.planSetTemplateConfigs[id];
      const planSetTemplate: PlanSetTemplate | undefined = Object.values(
        (json.planSetTemplates ?? {}) as { [id: string]: PlanSetTemplate },
      ).find((planSetTemplate) => planSetTemplate.id === planSetTemplateConfig.parentId);

      const planSetTemplateEntityRef = planSetTemplate ? json.entityRefs[planSetTemplate.id] : undefined;

      // If the plan set template is not doc ref'd, skip
      if (!planSetTemplateEntityRef) {
        continue;
      }

      // If the plan set template config is already doc ref'd, skip
      if (planSetTemplateEntityRef && json.entityRefs[id]) {
        continue;
      }

      // Create new entity ref for plan set template config
      json.entityRefs[id] = {
        id,
        entityId: id,
        docRefId: planSetTemplateEntityRef.docRefId,
      };
    }

    return json;
  },
};

export default migration_0_0_329;
